import React, { useState, useEffect } from 'react';
import './Dashboard.css';
import Header from '../components/Header';
import ProjectCard from '../components/ProjectCard';
import ProjectDetails from '../components/ProjectDetails';
import forgejoLogo from '../assets/forgejo.svg'
import githubLogo from '../assets/github-mark-white.svg'
import LinkedinLogo from '../assets/linkedIn.svg'
import projects from '../data/projects';

function Dashboard({projectId}) {
    const [selectedProjectId, setSelectedProjectId] = useState(projectId);

    useEffect(() => {setSelectedProjectId(projectId)}, [projectId])

    const handleProjectClick = (projectId) => {
        setSelectedProjectId(projectId);
        window.scrollTo(0, 0);
    };


    const selectedProject = selectedProjectId ? projects.find(p => p.id === selectedProjectId) : null;

    return (
        <div className="app">
            <Header 
                showBackButton={selectedProjectId !== null}
            />
            
            <main className="app-content">
                {selectedProject ? (
                    <ProjectDetails project={selectedProject} />
                ) : (
                    <div className="projects-list">
                        <div className="intro">
                            <h2>Freelance Development Experience</h2>
                            <p>
                            Below is a portfolio of my freelance projects.
                            Each project represents solutions to complex problems across various domains. This site is hosted on my rural farm in Northern, Ontario, Canada. If the site is down its most likely due to weather conditions like a blizzard if its winter. Relavent Links in the footer unfortunately a significant amount of my professional work is locked in private git, code commit and gitlab repos. If you've been given this site please feel free to contact me for more details.
                            </p>
                            <p>
                            This site is a minimal React site, hosted on my own git server with a custom CI/CD pipline hooked up to pm2 for loadbalancing across a proxmox cluster (mainly for other stuff but it hosts this site too). The images are hosted via Google drive so if too many people hit the site the images will stop loading. Thanks for your understanding.
                            
                            </p>
                        </div>
                        
                        {projects.map(project => (
                            <ProjectCard 
                            key={project.id}
                            project={project}
                            onClick={handleProjectClick}
                            />
                        ))}
                    </div>
                )}
            </main>
            
            <footer className="app-footer">
                <div className="footer-content">
                    <p>&copy; {new Date().getFullYear()} Comet Technologies | All Rights Reserved</p>
                    <div className="social-links">
                        <a href="https://github.com/2ManyProjects" target="_blank" rel="noopener noreferrer" className="social-icon">
                            <img src={githubLogo} alt="Github" width="24" height="24" />
                        </a>
                        <a href="https://git.2many.ca/root?tab=activity" target="_blank" rel="noopener noreferrer" className="social-icon">
                            <img src={forgejoLogo} alt="Forgejo" width="24" height="24" />
                        </a>
                        <a href="https://www.linkedin.com/in/shaiv-kamat-a39ba514a/" target="_blank" rel="noopener noreferrer" className="social-icon">
                            <img src={LinkedinLogo} alt="Linkedin" width="24" height="24" />
                        </a>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default Dashboard;